var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import GmailActionsOverTime from '@web/components/Apps/Gmail/GmailActionsOverTime';
import GmailSummary from '@web/components/Apps/Gmail/GmailSummary';
import StickyFilters from '@web/components/Filters/StickyFilters';
export var GmailTab = function () {
    return (_jsxs(_Fragment, { children: [_jsx(StickyFilters, {}), _jsxs("div", __assign({ className: "flex flex-col mx-1 gap-20 mt-5" }, { children: [_jsx(GmailSummary, {}), _jsx(GmailActionsOverTime, {})] }))] }));
};
